/**
 * Ceil a raw step to the next "nice number" — the {1, 2, 5} × 10^k series standard for axis and
 * ruler labelling (Heckbert, "Nice Numbers for Graph Labels", Graphics Gems). Ceiling rather
 * than rounding: a step chosen from a density target must never come out finer than that target,
 * or adjacent labels collide.
 */
export function ceilToNiceStep(rawStep: number): number {
  if (rawStep <= 0) return 0;
  const magnitude = 10 ** Math.floor(Math.log10(rawStep));
  const normalized = rawStep / magnitude;
  const niceNormalized = normalized <= 1 ? 1 : normalized <= 2 ? 2 : normalized <= 5 ? 5 : 10;
  return niceNormalized * magnitude;
}
